module.exports = "/legacy/391b0916dee161e6802b4e3ff8c9441a.svg";